import React, { ChangeEvent, FunctionComponent } from 'react'
import { Divider, Radio, RadioGroup } from '@afterpaytouch/core'
import { Country } from '@afterpay/types'

import { Weekday } from '../../model'
import { useCountry, useSelectedPreferredDay } from '../../state'
import { useTranslation } from '../../utils/convergence'

interface PaymentDayListProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const getTranslatedWeekdayLabel = (t: (key: string) => string, day: Weekday): string => {
  switch (day) {
    case 0:
      return t('preferredDay.weekday.0')
    case 1:
      return t('preferredDay.weekday.1')
    case 2:
      return t('preferredDay.weekday.2')
    case 3:
      return t('preferredDay.weekday.3')
    case 4:
      return t('preferredDay.weekday.4')
    case 5:
      return t('preferredDay.weekday.5')
    case 6:
      return t('preferredDay.weekday.6')
    default:
      return ''
  }
}

export const PaymentDayList: FunctionComponent<PaymentDayListProps> = ({ onChange }) => {
  const { t } = useTranslation()
  const countryCode = useCountry()
  const selectedPreferredDay = useSelectedPreferredDay()
  const days = countryCode === Country.CA || countryCode === Country.US ? [0, 1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5, 6, 0]

  const getLabelForDay = (day: Weekday): string => {
    switch (day) {
      case 0:
        return t('preferredDay.weekday.0')
      case 1:
        return t('preferredDay.weekday.1')
      case 2:
        return t('preferredDay.weekday.2')
      case 3:
        return t('preferredDay.weekday.3')
      case 4:
        return t('preferredDay.weekday.4')
      case 5:
        return t('preferredDay.weekday.5')
      case 6:
        return t('preferredDay.weekday.6')
      default:
        return ''
    }
  }

  return (
    <RadioGroup name='payment-days' indent defaultValue={`${selectedPreferredDay}`} onChange={onChange}>
      {days.map((day: Weekday, idx) => {
        const key = `payment-day-list-option-${day}`

        return [
          <Radio.Button key={key} label={getTranslatedWeekdayLabel(t, day)} value={`${day}`} labelWidth='Full' testNameSpace={key} />,
          idx !== days.length - 1 && <Divider margin='No' kind='Hairline' key={`payment-day-list-divider-${day}`} />,
        ]
      })}
    </RadioGroup>
  )
}
